{
  "CustomNameLabel": "Name:",
  "CustomWidthLabel": "Breite (0 - 100):",
  "CustomSettings_SectionHeader": "Benutzerdefinierte Einstellungen",
  "NAME": "CustomSettings"
}